module.exports = __webpack_public_path__ + "img/Tradedoubler-1024x123.80db953f.png";